import { render, staticRenderFns } from "./2_ConfirmRegister.vue?vue&type=template&id=1cdff251&scoped=true&"
import script from "./2_ConfirmRegister.vue?vue&type=script&lang=js&"
export * from "./2_ConfirmRegister.vue?vue&type=script&lang=js&"
import style0 from "./2_ConfirmRegister.vue?vue&type=style&index=0&id=1cdff251&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cdff251",
  null
  
)

export default component.exports